/* smooth-scroll — site-wide smooth scrolling via Lenis.

   Lenis smooths the NATIVE scroll; it does not wrap or transform the DOM. That
   means the sticky header, the fixed cart drawer / age gate, and the product
   buy-bar all keep working with zero markup changes (unlike GSAP ScrollSmoother,
   which needs a transformed #smooth-wrapper that breaks fixed positioning).

   Inert (plain native scroll) when:
     - in the Shopify theme editor (Shopify.designMode);
     - the visitor prefers reduced motion;
     - Lenis failed to load. */
(function () {
  if (window.__smoothScrollInit) return;
  window.__smoothScrollInit = true;

  const inEditor = window.Shopify && window.Shopify.designMode;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (inEditor || reduceMotion || typeof window.Lenis !== 'function') return;

  const lenis = new window.Lenis({
    duration: 1.1,     // ~how long the scroll takes to ease to a stop
    smoothWheel: true, // smooth mouse-wheel / trackpad
    syncTouch: false,  // native scroll on touch devices — feels better there
  });

  // Prefer GSAP's ticker so Lenis, GSAP tweens and ScrollTrigger all run on ONE
  // requestAnimationFrame loop. Two competing rAF loops (Lenis' own + GSAP's)
  // drop frames on a cold load — that's the first-paint jank. lagSmoothing(0)
  // stops GSAP from time-warping tweens to "catch up" after a busy first frame,
  // which is what makes the very first reveals look like they snap/skip.
  if (window.gsap && window.gsap.ticker) {
    const gsap = window.gsap;
    gsap.ticker.add((time) => lenis.raf(time * 1000)); // GSAP ticker time is in seconds
    gsap.ticker.lagSmoothing(0);
    if (window.ScrollTrigger) lenis.on('scroll', window.ScrollTrigger.update);
  } else {
    // GSAP missing → Lenis drives its own loop.
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
  }

  // Smooth in-page anchor links (#section), respecting a fixed-header offset.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href');
    if (id.length < 2) return;
    const target = document.querySelector(id);
    if (!target) return;
    event.preventDefault();
    lenis.scrollTo(target, { offset: -100 });
  });

  window.lenis = lenis;
})();
